<template>
  <div class="h-full">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'LayoutLogin'
};
</script>
